import axios from 'axios';
import { toast } from 'sonner';
import { z } from 'zod';

const configSchema = z.object({
  VITE_REST_URL: z.string().url(),
  VITE_PERMISSION_API_URL: z.string().url(),
  VITE_OAUTH_URL: z.string().url(),
  SERVICE_PORTAL: z.string().url(),
  VITE_CLIENT_ID: z.string(),
  VITE_NOTIFICATIONS_WS_URL: z.string().url(),
  ENABLE_RUM: z.boolean(),
  DEMO_ID: z.string(),
  VITE_ENVIRONMENT: z.union([z.literal('development'), z.literal('production'), z.literal('qa')]),
  RUM_ACCESS_TOKEN: z.string(),
});

export type Config = z.infer<typeof configSchema>;

let config: Config | undefined;

export const loadConfig = async (): Promise<void> => {
  if (config) {
    return;
  }

  try {
    const response = await axios.get('./config.json');
    config = configSchema.parse(response.data);
  } catch (error: unknown) {
    toast.error('Failed to load or validate configuration', {
      description: error instanceof Error ? error.message : undefined,
    });
    throw new Error('Configuration loading failed');
  }
};

export const getConfig = (): Config => {
  if (!config) {
    throw new Error('Configuration has not been loaded yet');
  }

  return config;
};
